<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新建规程': '修改规程'",width="95%",:visible.sync='visible' :modal-append-to-body='false' @close="closeForm()")
      el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="100px", @submit.native.prevent)
          el-card(shadow="never")
              el-form-item(label="规程标题:" prop='title')
                  el-input.width_ct(v-model="ruleForm.title" placeholder="请填规程标题" type="text" )
              el-form-item(label="摘　　要:" prop='remark')
                  el-input.width_ct(v-model="ruleForm.remark" maxlength="200" show-word-limit type="textarea" :rows=6 resize="none" placeholder="请填写摘要" )
              el-form-item(label="发布日期:" prop="releaseTim" placeholder="请选择发布日期")
                  el-date-picker.sel_width_ct(v-model="ruleForm.releaseTim" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" clearable)
              el-form-item(label="类型:" prop="type")
                  el-select.sel_width_ct(v-model='ruleForm.type' placeholder="请选择类型"  clearable)
                      el-option(value="1" label='竞赛')
                      el-option(value="2" label='培训')
              el-form-item(label="上传文件:" )
                  el-upload(ref="uploada" :http-request="uploadFileList",action="useless" :limit='1' :multiple='false' :before-upload="beforeAvatarUpload" :show-file-list="true" class="avatar-uploader" placeholder="选择上传文件")
                    el-button( type="primary" ) 选择文件
              el-form-item(label="已上传文件:" v-if="filePath!=''")
                    a(:href="filePath" :download="fileName" style='color:#606266') {{fileName}}
                    //- img(v-if="listImageUrl" :src="listImageUrl" class="avatar" )
                    //- i(v-else class="el-icon-plus avatar-uploader-icon")
              el-form-item(label="正文:" prop="details")
                  d2-quill(ref="d2-quill" v-model="ruleForm.details" style="min-height: 200px;")

      span.dialog-footer(slot="footer")
          el-button(type="primary" @click="ruleFormSubmit()") 确 定
          el-button(@click="closeForm()") 取 消
</template>
<script>
    export default {
        data () {
            return {
                sysOrgList: [],
                ruleForm: {
                    title: '',
                    remark: '',
                    type: '',
                    releaseTim: '',
                    attach: '',
                    details: '',
                    id: null
                },
                flagType: '',
                loading: null,
                rules: {
                    title: [
                        { required: true, message: '规程标题不能为空!', trigger: 'blur' },
                        { max: 20, message: '长度不能超过20个字符!' }
                    ],
                    releaseTim: [
                        { required: true, message: '发布日期不能为空!', trigger: 'blur' }
                    ],
                    type: [
                        { required: true, message: '类型不能为空!', trigger: 'blur' }
                    ]

                },
                visible: false,
                listshow: false,
                listImageUrl: '',
                detailImageUrl: '',
                fileName: '暂无文件！',
                filePath: ''

            }
        },
        mounted () {

        },
        methods: {
            init (id, flagType) {
                this.flagType = flagType
                this.ruleForm.id = id || null
                this.listImageUrl = ''
                this.fileName = ''
                this.filePath = ''
                this.visible = true

                this.$nextTick(() => {
                    this.$refs['ruleForm'].resetFields()
                    this.$refs['d2-quill'].Quill.pasteHTML('')
                })
                //数据初始
                //修改回选
                if (this.ruleForm.id) {
                    this.$http({
                        url: this.$http.adornUrl(`/pbStandards/getId/` + this.ruleForm.id),
                        method: 'get'
                    }).then((data) => {
                        if (data && data.code === 0) {
                            console.log(data)
                            this.ruleForm.title = data.bean.title
                            this.ruleForm.remark = data.bean.remark
                            this.ruleForm.type = data.bean.type
                            this.ruleForm.releaseTim = data.bean.releaseTime
                            this.$refs['d2-quill'].Quill.pasteHTML(data.bean.details)
                            if (data.bean.imgUrl != '' && data.bean.imgUrl != null) {
                                this.filePath = data.bean.imgUrl
                                this.fileName = data.bean.imgName
                                // this.listImageUrl = "data:image/png;base64,"
                            }
                        }
                    })
                }
            },
            download () {
                this.$http({
                    url: this.$http.adornUrl(`/pbStandards/download?path=${this.filePath}`),
                    method: 'get'
                }).then(res => {
                    console.log(res, 988)
                })
            },
            openFullScreen () {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },
            //新增方法
            ruleFormSubmit () {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        let data = {
                            id: this.ruleForm.id,
                            title: this.ruleForm.title,
                            remark: this.ruleForm.remark,
                            type: this.ruleForm.type,
                            attach: this.ruleForm.attach,
                            releaseTime: this.ruleForm.releaseTim,
                            details: this.ruleForm.details
                        }
                        this.openFullScreen()
                        this.$http({
                            url: this.$http.adornUrl(`/pbStandards/${!this.ruleForm.id ? 'save' : 'update'}`),
                            method: 'post',
                            data: data
                        }).then((data) => {
                            this.loading.close()
                            if (data && data.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        }).catch(() => {
                            this.loading.close()
                        })
                    }
                })
            },
            closeForm () {
                this.visible = false
                if (this.$refs.uploada) {
                    this.$refs.uploada.clearFiles()
                }
                // if(this.flagType==2){
                //     this.$http({
                //         url: this.$http.adornUrl(`/ctCompetition/delete/`+this.ruleForm.id),
                //         method: "get"
                //     }).then(data => {
                //         this.visible = false
                //     });
                // }else{
                //     this.visible = false
                // }
            },
            //文件上传前的验证
            beforeAvatarUpload (file) {
                console.log(file.name)
            var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
            const doc = fileType === 'doc'
            const docx = fileType === 'docx'
            const pdf = fileType === 'pdf'
            const txt = fileType === 'txt'
            if (!doc && !docx && !pdf && !txt) {
                this.$message.error({
                    message: '上传文件只能是 doc、docx、pdf、txt格式!'
                })
            }
            return doc || docx || pdf || txt
            },

            //自定义上传方法
            //没有用el-upload的action方法，如果使用要传递headers属性参数授权
            uploadFileList (param) {
                //列表页图
                console.log(param, 999)
                // this.paramlist = param
                this.uploadFile('1', param.file)
            },
            uploadFileDetail (param) {
                //列表页图
                this.uploadFile('2', param.file)
            },
            uploadFile (type, file) {
                let fd = new FormData()
                fd.append('type', 'pbStandards')
                fd.append('file', file)
                this.$http({
                    url: this.$http.adornUrl(`/upload/uploadFile`),
                    method: 'post',
                    data: fd
                }).then((data) => {
                    if (data && data.code === 0) {
                        //列表页图
                        if (type == '1') {
                            this.ruleForm.attach = data.bean.id
                            this.listImageUrl = URL.createObjectURL(file)
                        }
                        //详情页图
                        if (type == '2') {
                            this.ruleForm.imgDetailList = data.bean.id
                            this.detailImageUrl = URL.createObjectURL(file)
                        }
                        this.$message.success('上传成功!')
                    } else {
                        this.$message.error('上传失败!')
                    }
                })
            }

        }
    }
</script>
<style scoped>
/* .avatar-uploader{
    width: 30%;
}
    .avatar-uploader >>>.el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    float: right;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}

.el-upload-list {
  display: inline-block;
  width: 300px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
}
.el-upload-list__item {
  margin-top: 0px;
  height: 40px;
  line-height: 40px;
}
.el-upload-list__item:first-child {
  margin-top: 0px;
}
.el-upload-list__item:hover .el-icon-close {
  display: inline-block;
  line-height: 30px;
}
/* 弹出遮罩层 兼容ie*/
.el-dialog__wrapper {
  width: 100% !important;
  height: 100% !important;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
}
/* 文本框剩余数字提示兼容ie */
.el-textarea >>> .el-input__count {
  color: #909399;
  background: none;
  position: absolute;
  font-size: 12px;
  bottom: 5px;
  right: 20px;
}
</style>
